import React, { useState, useEffect } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Identity } from '@wajeez-web/core/api-base';
import { useRolesSelector, TeamActions } from '@wajeez-web/stores/roles';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import { CustomerCareActions } from '@wajeez-web/stores/customers';
import { InputSelect, SearchInput } from '@wajeez-web/components/ui';

export interface AssignNewUserRoleOutputProps {
  userId: string;
  userRoles: Identity.UserRoleModel[];
}
const AssignNewUserRoleModal: React.FC<
  CommonModalProps<AssignNewUserRoleOutputProps>
> = ({ isOpen, onClose, onSubmit }) => {
  const { userRoles } = useRolesSelector((state) => state.wajeezTeam);
  const [selectedRole, setSelectedRole] = useState<Identity.UserRoleModel[]>(
    []
  );
  const [selectedUser, setSelectedUser] = useState('');
  const dispatch = useCommonDispatch();

  useEffect(() => {
    if (userRoles) {
      setSelectedRole(
        userRoles?.userRoles?.filter((ele) => ele.selected) || []
      );
    }
  }, [userRoles]);

  useEffect(() => {
    return () => {
      dispatch(TeamActions.clearUserRoles());
    };
  }, []);

  return (
    <Modal
      onSubmit={() => {
        onSubmit && onSubmit({ userId: selectedUser, userRoles: selectedRole });
      }}
      open={isOpen}
      onClose={onClose}
      title="Assign Role to User"
    >
      <div>
        <SearchInput
          name="id"
          // value={asiggnedUserData.id}
          debounceTime={100}
          onSearch={(val) => {
            return dispatch(CustomerCareActions.getUsersByEmailAsync(val)).then(
              (res) => {
                if (res.payload) {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  return res.payload.map(
                    (item: { id: string; email: string }) => ({
                      label: item.email,
                      value: item.id,
                    })
                  );
                }
              }
            );
          }}
          onChange={(name, val: any) => {
            dispatch(TeamActions.getUserRolesAsync(val.value));
            setSelectedUser(val.value);
          }}
        />
        <InputSelect
          options={
            userRoles?.userRoles?.map((r) => ({
              value: r.roleName,
              label: r.roleName,
            })) || []
          }
          label="Role"
          name="roleId"
          isMulti={true}
          value={selectedRole?.map((r) => ({
            value: r.roleName || '',
            label: r.roleName || '',
          }))}
          onChange={(name, val: any) =>
            setSelectedRole(
              val.map((ele: any) => ({ roleName: ele.value, selected: true }))
            )
          }
        />
      </div>
    </Modal>
  );
};

export default AssignNewUserRoleModal;
